import { CabecalhoDePagina, toast } from "@base/ui";
import { FormularioDePerfil } from "./formulario-de-perfil";

/** Meu perfil: a pessoa revisa e altera nome, telefone e cargo. */
export function PaginaDePerfil({
  usuario,
  cargoNoPainel,
}: {
  readonly usuario: { nome: string; email: string; telefone: string | null; cargo: string | null };
  /** Administrador / Gestor / Membro, so para mostrar. */
  readonly cargoNoPainel: string;
}) {
  return (
    <div className="flex flex-col gap-secao">
      <CabecalhoDePagina
        rotulo="Minha conta"
        titulo="Meu perfil"
        descricao={`Seus dados de contato. No painel, seu acesso é de ${cargoNoPainel.toLowerCase()}.`}
      />
      <div className="max-w-xl rounded-3xl bg-card p-6 shadow-sm ring-1 ring-border/70 md:p-8">
        <FormularioDePerfil
          key={`${usuario.nome}|${usuario.telefone}|${usuario.cargo}`}
          inicial={usuario}
          textoDoBotao="Salvar alterações"
          aoSalvar={() => toast.success("Perfil atualizado")}
        />
      </div>
    </div>
  );
}
